import type { Writable } from 'svelte/store';
import { writable } from 'svelte/store';
import { browser } from '$app/environment';

export interface SweatUser {
  user_metadata: {
    sweat_user_id: string | number;
    sweat_user_access_token: string;
    user_canonical_id: string;
    user_login_method: string;
    user_created_at: string;
    user_dob: string;
  };
  given_name?: string;
  family_name?: string;
  name: string;
  picture: string;
  email: string;
  sub: string;
}

interface UserStoreState {
  user: SweatUser | null;
  isAuthenticated: boolean;
  loading: boolean;
  promo_code: string | null;
}

const initialState: UserStoreState = {
  user: null,
  isAuthenticated: false,
  loading: true,
  promo_code: null,
};

function createUserStore() {
  const { subscribe, set, update } = writable<UserStoreState>(initialState);

  if (browser) {
    //When the state changes, sync selected parts with sessionStorage
    //This uses sessionStorage (rather than a session-backed store) so we can retrieve the values directly when we need them
    //Don't remove the canonical ID once set, because we don't want to remove it before the value is populated
    subscribe((state) => {
      const canonical_id = state.user?.user_metadata.user_canonical_id;
      canonical_id ? sessionStorage.setItem('user_canonical_id', canonical_id) : null;

      const promo_code = state.promo_code;
      promo_code
        ? sessionStorage.setItem('promo_code', promo_code)
        : sessionStorage.removeItem('promo_code');
    });
  }

  const setUser = (user: SweatUser) => {
    update((store) => {
      store.user = user;
      if (user?.given_name && user?.family_name) {
        store.user.name = `${user.given_name} ${user.family_name}`;
      }
      store.isAuthenticated = !!user;
      store.loading = false;
      return store;
    });
  };

  return {
    subscribe,
    set,
    update,
    setUser,
  };
}

export const userStore = createUserStore();
export const setUser = userStore.setUser;
